export const LOCATIONS = "LOCATIONS";
export const LOCATION_BUSY = "LOCATION_BUSY";
export const LOCATIONS_COUNT = "LOCATIONS_COUNT";
export const LOCATION_PAGINATION = "LOCATION_PAGINATION";
